package co.maytes.standupbot.dashboard.features.standupslist

import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.shared.dto.standup.StandupDto
import com.kttipay.mvi.api.Container
import com.kttipay.mvi.api.StoreScope
import com.kttipay.mvi.dsl.store
import kotlinx.coroutines.CoroutineScope

class StandupsListContainer(
    scope: CoroutineScope,
    private val api: ApiClient,
) : Container<StandupsListContract.State, StandupsListContract.Intent, StandupsListContract.Action> {

    override val store = scope.store<
            StandupsListContract.State,
            StandupsListContract.Intent,
            StandupsListContract.Action,
            >(initialState = StandupsListContract.State()) {
        configure(name = "StandupsList")
        logging()
        reduce { intent ->
            when (intent) {
                is StandupsListContract.Intent.Load -> load(intent.workspaceId)
                StandupsListContract.Intent.Retry -> {
                    val ws = currentState.workspaceId ?: return@reduce
                    load(ws)
                }
                is StandupsListContract.Intent.OpenDetail ->
                    action(StandupsListContract.Action.Navigate("/app/standups/${intent.standupId}"))
                StandupsListContract.Intent.Create ->
                    action(StandupsListContract.Action.Navigate("/app/standups/new"))
            }
        }
    }

    private suspend fun StoreScope<StandupsListContract.State, StandupsListContract.Action>.load(
        workspaceId: String,
    ) {
        updateState {
            copy(
                workspaceId = workspaceId,
                status = if (showsRows) StandupsListContract.Status.Refreshing else StandupsListContract.Status.Loading,
                hasEntered = showsRows,
            )
        }
        when (val res = api.get<List<StandupDto>>("/api/v1/workspaces/$workspaceId/standups")) {
            is Result.Ok ->
                updateState {
                    copy(items = res.value, status = StandupsListContract.Status.Ready)
                }
            is Result.Err ->
                updateState {
                    copy(status = StandupsListContract.Status.Error(res.error))
                }
        }
    }
}
